import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";

import { RobotoUserConfigKey } from "../ConfigRecords";

import * as GetUserConfig from "./useUserConfig";

export function useUpdateUserConfig() {
  const queryClient = useQueryClient();
  const { configService } = useDomainServices();
  // The write has to land on the same identity-partitioned key `useUserConfig`
  // reads from, or the fresh value would be stranded in an entry nobody reads.
  const { currentUser } = useAuth();

  return useMutation({
    mutationFn: async ({
      key,
      value,
    }: {
      key: RobotoUserConfigKey;
      value: unknown;
    }) => {
      return configService.setUserConfig(key, value);
    },
    onSuccess: (_, { key, value }) => {
      return queryClient.setQueryData(
        GetUserConfig.getQueryKey(currentUser?.user_id, key),
        value,
      );
    },
  });
}
